import {carUrls, car} from './car'
import {cardetailUrls, cardetail} from './cardetail'

export const recordUrls = [
  ...carUrls,
  ...cardetailUrls
]

export const record = {
  car,
  cardetail
}



// WEBPACK FOOTER //
// ./src/api/gip/record/index.js